import { ConfigProvider, Switch } from "antd";
import './editor-data-viewer.css';
import { ToolModal } from "../tool-modal/tool-modal";
import { useState } from "react";
import { ModelTreeInModelSpace } from "./model-tree-in-model-space/model-tree-in-model-space";
import { ProcessStepsViewer } from "./process-steps-viewer/process-steps-viewer";
import { ModelInModelTree } from "../model-space/model-space";
import { LayersViewer } from "./layers-viewer/layers-viewer";
import { Project } from "../../types/api/project/get-project-success-response";
import { ModelEditorType } from "../../pages/cms/company-admin/projects/modules/models/index/company-admin-model-index";
import { Tool } from "../../types/api/tool/get-tools-success-response";
import { CMSButton } from "../../../../components/cms/button/cms-button.";
import { NewProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName, ProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName } from "../../types/api/process-step/get-process-steps-success-response";
import { LayerWithNewLayerItemTooAndChangeableSubmodelName, NewLayerithChangeableSubmodelName } from "../../types/api/layer/layer";
import { getImageUrl } from "../../../../utils/image-helper/get-image-url";

type EditorDataViewerProps = {
    project: Project;
    activeTab: ModelEditorType;
    onTabChange: (tab: ModelEditorType) => void;

    // model space-hez tartozó proeprty-k
    modelTreeInModelSpace?: ModelInModelTree[];
    selectedModelUUIDInModelSpace: string | null;
    onSelectModelInModelSpace: (uuid: string | null) => void;
    onSelectModelWithDoubleClickInModelSpace?: (uuid: string) => void;
    onChangeModelNameInModelSpace: (uuid: string, name: string) => void;
    onVisibleChangeInModelSpace: (uuid: string, visible: boolean) => void;
    areModelSpaceModelsLoading: boolean;

    // process steps viwer-höz tartozó property-k
    processSteps: (ProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName | NewProcessStepWithEndpointModelGeneratedAndDoneAndStartingModelName)[];
    selectedProcessStepItemId: number | null;
    selectedProcessStepId: number | null;
    onProcessStepSelect: (processStepId: number | null) => void;
    onProcessStepItemModelSelect: (uuid: string | null) => void;
    onProcessStepItemSelect: (processStepItemId: number | null) => void;
    onAddNewProcessStep: (id: number, name: string) => void;
    onAddNewProcessStepItem: (id: number, processStepId: number) => void;
    onToolChoseForProcessStepItem: (processStepItemId: number, tool: Tool) => void;
    onProcessStepNameChange?: (processStepId: number, name: string) => void;
    onProcessStepDelete?: (processStepId: number) => void;
    onProcessStepItemDelete?: (processStepItemId: number) => void;
    selectedModelUUIDInProcessEditor: string | null;
    procesStepsViewerDisabled: boolean;
    onProcessStepItemStartingModelClick?: (processStepItemId: number) => void;
    onSettingProcessStepItemStartingModelVisible?: (processStepItemId: number, visible: boolean) => void;
    onSettingProcessStepItemModelToBeMovedConnectedToReferenceModel?: (processStepItemId: number, connected: boolean) => void;
    onProcessStepIteReferenceModelClick?: (processStepItemId: number) => void;
    onProcessStepItemOtherModelChooseForReferenceModelClick?: (processStepItemId: number) => void;
    onToolDeleteForProcessStepItem?: (processStepItemId: number) => void;
    onProcessStepItemEndpointClick?: (processStepItemId: number) => void;
    onProcessStepItemEndpointDeleteClick?: (processStepItemId: number) => void;
    onProcssStepItemDoneClick?: (processStepItemId: number) => void;

    // layer editor viewer-hez tartozó property-k
    layers: (LayerWithNewLayerItemTooAndChangeableSubmodelName | NewLayerithChangeableSubmodelName)[];
    selectedLayerId: number | null;
    selectedLayerItemId: number | null;
    selectedModelUUIDInLayerEditor: string | null;
    layersViewerDisabled: boolean;
    onLayerItemModelSelect: (uuid: string | null) => void;
    onLayerSelect: (layerId: number | null) => void;
    onLayerItemSelect: (layerItemId: number | null) => void;
    onNewLayerAdd: (id: number, name: string) => void;
    onNewLayerItemAdd: (id: number, layerId: number, name: string) => void;
    onLayerNameChange?: (layerId: number, name: string) => void;
    onLayerItemNameChange?: (layerItemId: number, name: string) => void;
    onLayerDelete?: (layerId: number) => void;
    onLayerItemDelete?: (layerItemId: number) => void;
    onLayerItemModelSelectClick?: (layerItemId: number) => void;
    onLayerItemOtherModelChooseClick?: (layerItemId: number) => void;
    onLayerItemSubmodelSelectClick?: (layerItemId: number) => void;
    onLayerItemOtherSubmodelChooseClick?: (layerItemId: number) => void;
    onLayerItemSubmodelNameClick?: (layerItemId: number) => void;
    onLayerItemSubmodelNameCancelClick?: (layerItemId: number) => void;
    onLayerItemSubmodelNameSaveClick?: (layerItemId: number, name: string) => void;

    onSave?: () => void;
    needSave: boolean;

    isPOIActive?: boolean;
    onIsPOIActiveChange?: (isActive: boolean) => void;
};

export const EditorDataViewer = ({
    project,

    activeTab,
    onTabChange,

    // model space property-k
    selectedModelUUIDInModelSpace,
    onSelectModelInModelSpace,
    onChangeModelNameInModelSpace,
    modelTreeInModelSpace = [],
    onVisibleChangeInModelSpace,
    areModelSpaceModelsLoading,
    onSelectModelWithDoubleClickInModelSpace,

    // process steps viewer property-k
    selectedProcessStepId,
    selectedProcessStepItemId,
    processSteps,
    onProcessStepItemModelSelect,
    onProcessStepItemSelect,
    onProcessStepSelect,
    onAddNewProcessStep,
    onAddNewProcessStepItem,
    onToolChoseForProcessStepItem,
    onProcessStepNameChange,
    onProcessStepDelete,
    onProcessStepItemDelete,
    selectedModelUUIDInProcessEditor,
    procesStepsViewerDisabled,
    onProcessStepItemStartingModelClick,
    onSettingProcessStepItemModelToBeMovedConnectedToReferenceModel,
    onProcessStepIteReferenceModelClick,
    onProcessStepItemOtherModelChooseForReferenceModelClick,
    onToolDeleteForProcessStepItem,
    onProcessStepItemEndpointClick,
    onProcessStepItemEndpointDeleteClick,
    onProcssStepItemDoneClick,
    onSettingProcessStepItemStartingModelVisible,

    // layers viewer property-k
    layers,
    layersViewerDisabled,
    selectedLayerId,
    selectedLayerItemId,
    selectedModelUUIDInLayerEditor,
    onLayerSelect,
    onLayerItemSelect,
    onLayerNameChange,
    onLayerItemNameChange,
    onLayerItemModelSelect,
    onNewLayerAdd,
    onNewLayerItemAdd,
    onLayerDelete,
    onLayerItemDelete,
    onLayerItemModelSelectClick,
    onLayerItemOtherModelChooseClick,
    onLayerItemSubmodelSelectClick,
    onLayerItemOtherSubmodelChooseClick,
    onLayerItemSubmodelNameClick,
    onLayerItemSubmodelNameCancelClick,
    onLayerItemSubmodelNameSaveClick,

    onSave,
    needSave,

    isPOIActive,
    onIsPOIActiveChange
}: EditorDataViewerProps) => {
    const [isToolModalOpen, setIsToolModalOpen] = useState(false);

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: '#129B49'
            }
        }}>
            <div className="editor-data-viewer">
                
                <div className="buttons">
                    <span className='poi'>
                        POI&nbsp;
                        <Switch
                            checked={isPOIActive}
                            onChange={(checked) => { if (onIsPOIActiveChange) onIsPOIActiveChange(checked); }}
                            disabled={project.workInstructionModule === false}
                        />
                    </span>
                    <CMSButton style={{ padding: '2px 15px' }} text={`Mentés${ needSave ? '*' : '' }`} type="pink" iconSrc={getImageUrl('Save-icon.png')} onClick={() => { if (onSave) onSave(); }} />
                </div>

                <div className="tabs">
                    {
                        project.modelSpaceModule && (
                            <div
                                className={`${ activeTab === 'modelSpace' && 'active' }`}
                                onClick={
                                    () => {
                                        if (activeTab === 'modelSpace') return;

                                        if (needSave) {
                                            if (window.confirm('Biztosan átvált a modelltérre? Ha átvált az eddigi adatok elvesznek a jelenlegi szerkesztőnél.'))
                                                onTabChange('modelSpace');
                                        } else onTabChange('modelSpace');
                                    }
                                }
                            >
                                Modell
                            </div>
                        )
                    }
                    {
                        project.processEditorModule && (
                            <div
                                className={`${ activeTab === 'processEditor' && 'active' }`}
                                onClick={
                                    () => {
                                        if (activeTab === 'processEditor') return;

                                        if (needSave) {
                                            if (window.confirm('Biztosan átvált a folyamatszerkesztőre? Ha átvált az eddigi adatok elvesznek a jelenlegi szerkesztőnél.'))
                                                onTabChange('processEditor');
                                        } else onTabChange('processEditor');
                                    }
                                }

                            >
                                Folyamat
                            </div>
                        )
                    }
                    {
                        project.layerEditorModule && (
                            <div
                                className={`${ activeTab === 'layerEditor' && 'active' }`}
                                onClick={
                                    () => {
                                        if (activeTab === 'layerEditor') return;

                                        if (needSave) {
                                            if (window.confirm('Biztosan átvált a rétegszerkesztőre? Ha átvált az eddigi adatok elvesznek a jelenlegi szerkesztőnél.'))
                                                onTabChange('layerEditor');
                                        } else onTabChange('layerEditor');
                                    }
                                }
                            >
                                Rétegek
                            </div>
                        )
                    }
                </div>

                <div className='data'>
                    {
                        project.modelSpaceModule && activeTab === 'modelSpace' && (
                            <div className="position-relative">

                                {
                                    areModelSpaceModelsLoading && (
                                        <div className="loader">
                                            <div className='spinner'>
                                                <div className='spinner-border'></div>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="mb-2">
                                    <span
                                        className="tool-handling-btn"
                                        onClick={() => setIsToolModalOpen(true)}
                                    >
                                        Szerszámok kezelése -&gt;
                                    </span>
                                    <ToolModal
                                        isListModalOpen={isToolModalOpen}
                                        setIsListModalOpen={setIsToolModalOpen}
                                    />
                                </div>

                                <div className="model-space-models">
                                    <b>Modellek:</b>
                                    <ModelTreeInModelSpace
                                        models={modelTreeInModelSpace}
                                        onSelect={(uuid) => onSelectModelInModelSpace(uuid)}
                                        selectedUUID={selectedModelUUIDInModelSpace}
                                        onModelNameChange={onChangeModelNameInModelSpace}
                                        onVisibleChange={onVisibleChangeInModelSpace}
                                        onSelectWithDoubleClick={onSelectModelWithDoubleClickInModelSpace}
                                    />
                                    {/*<ul>
                                        {
                                            modelsForModelSpace.map((model) => (
                                                <li
                                                    key={model.id}
                                                    className={(selectedModelIdInModelSpace === model.id) ? 'active' : ''}
                                                    onClick={() => onSelectModelIdInModelSpace(model.id)}
                                                >
                                                    <ModelNameHandler
                                                        defaultValue={model.name}
                                                        onSave={
                                                            (name) => {
                                                                if (onChangeModelNameInModelSpace) onChangeModelNameInModelSpace(model.id, name);
                                                            }
                                                        }
                                                    />
                                                </li>
                                            ))
                                        }
                                    </ul>*/}
                                </div>

                            </div>
                        )
                    }

                    {
                        project.processEditorModule && activeTab === 'processEditor' && (
                            <ProcessStepsViewer
                                project={project}
                                processSteps={processSteps}
                                selectedModelUUID={selectedModelUUIDInProcessEditor}
                                selectedProcessStepItemId={selectedProcessStepItemId}
                                selectedProcessStepId={selectedProcessStepId}
                                onProcessStepSelect={onProcessStepSelect}
                                onProcessStepItemSelect={onProcessStepItemSelect}
                                onProcessStepItemModelSelect={onProcessStepItemModelSelect}
                                onAddNewProcessStep={onAddNewProcessStep}
                                onAddNewProcessStepItem={onAddNewProcessStepItem}
                                onToolChooseForProcessStepItem={onToolChoseForProcessStepItem}
                                onProcessStepNameChange={onProcessStepNameChange}
                                onProcessStepDelete={onProcessStepDelete}
                                onProcessStepItemDelete={onProcessStepItemDelete}
                                disabled={procesStepsViewerDisabled}
                                onStartingModelClick={onProcessStepItemStartingModelClick}
                                onSettingStartingModelVisible={onSettingProcessStepItemStartingModelVisible}
                                onSettingModelToBeMovedConnectedToReferenceModel={onSettingProcessStepItemModelToBeMovedConnectedToReferenceModel}
                                onReferenceModelClick={onProcessStepIteReferenceModelClick}
                                onOtherModelChooseForReferenceModelClick={onProcessStepItemOtherModelChooseForReferenceModelClick}
                                onToolDeleteForProcessStepItem={onToolDeleteForProcessStepItem}
                                onEndpointModelClick={onProcessStepItemEndpointClick}
                                onEndpointModelDeleteClick={onProcessStepItemEndpointDeleteClick}
                                onDoneClick={onProcssStepItemDoneClick}
                            />
                        )
                    }

                    {
                        project.processEditorModule && activeTab === 'layerEditor' && (
                            <LayersViewer
                                layers={layers}
                                disabled={layersViewerDisabled}
                                project={project}
                                selectedLayerId={selectedLayerId}
                                selectedLayerItemId={selectedLayerItemId}
                                selectedModelUUID={selectedModelUUIDInLayerEditor}
                                onLayerItemModelSelect={onLayerItemModelSelect}
                                onLayerSelect={onLayerSelect}
                                onLayerItemSelect={onLayerItemSelect}
                                onNewLayerAdd={onNewLayerAdd}
                                onNewLayerItemAdd={onNewLayerItemAdd}
                                onLayerDelete={onLayerDelete}
                                onLayerItemDelete={onLayerItemDelete}
                                onLayerNameChange={onLayerNameChange}
                                onLayerItemNameChange={onLayerItemNameChange}
                                onModelSelectClick={onLayerItemModelSelectClick}
                                onOtherModelChooseClick={onLayerItemOtherModelChooseClick}
                                onSubmodelSelectClick={onLayerItemSubmodelSelectClick}
                                onOtherSubmodelChooseClick={onLayerItemOtherSubmodelChooseClick}
                                onSubmodelNameClick={onLayerItemSubmodelNameClick}
                                onSubmodelNameCancelClick={onLayerItemSubmodelNameCancelClick}
                                onSubmodelNameSaveClick={onLayerItemSubmodelNameSaveClick}
                            />
                        )
                    }
                </div>

            </div>
        </ConfigProvider>
    );
};